import {Image, Stack } from '@chakra-ui/react';
import React from 'react';
import { getImageURL } from '../util/getImage';
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const placeholderImg = `${IMAGE_BASE_PATH}/ui/DummyImage/small.png`

const ImagePreview = ({ image, variant = "default" }) => {
  const isThumbnail = variant === "thumbnail";
  const width = isThumbnail ? { base: "140px", md: "160px" } : { base: "100%", md: "450px" };
  const marginTop = isThumbnail ? { base: "8px", md: "8px" } : { base: "15px", md: "0" };
  const marginX = isThumbnail ? { base: "0", md: "0" } : { base: "20px", md: "30px" };
  const containerPadding = isThumbnail ? { base: "2", md: "2" } : { base: "4", md: "4" };
  const imageWidth = isThumbnail ? 140 : 370;
  const imageHeight = isThumbnail ? 140 : 550;
 
   return (
      <Stack
      width={width}
      marginTop={marginTop}
      marginX={marginX}
      flexDirection={{ base: "column", md: "column" }}
      gap={{base:"0",md:"8"}}>
        <Stack p={containerPadding}
          border={"0.01rem solid #b3b3b3"}
          borderRadius={"5px"}
          >
          <Image
              src={
                getImageURL(image,
                imageWidth,
                imageHeight
              )}
              fallbackSrc={placeholderImg}
              width={"100%"}
              height={isThumbnail ? "120px" : "inherit"}
              objectFit={"contain"}
              alt=""
              />
        </Stack>
      </Stack>
    )
}

export default ImagePreview;